module.exports = __webpack_public_path__ + "img/anvil-hammer.7834bf6f.svg";